import styled from 'styled-components'
export const container = styled.div`
  display: flex;
  width: 100%;
  @media screen and (max-width: 768px) {
    display: none;
  }
`
export const Box = styled.button`
  border: 2px solid var(--Gold-stroke, #feeac3);
  background: #101010;
  flex-basis: 25%;
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 8px;
  .box-title {
    flex-direction: column;
    gap: 5px;
    color: #fff;
    align-items: flex-start;
    display: flex;
    font-family: Inter;

    font-style: normal;

    line-height: normal;
  }
  .box-title1 {
    font-size: 14px;
    font-weight: 400;
  }
  .box-title2 {
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    background: var(
      --Gold-stroke,
      linear-gradient(180deg, #feeac3 0%, #ffe6a6 29.17%, #ffb800 100%)
    );
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    &:hover {
      background: var(
        --Button-hover,
        linear-gradient(180deg, #f00 0%, #ffd02b 100%)
      );
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }
`
export const AvatarImg = styled.div`
  text-algin: center;

  //   width: 45px;
  //   height: 45px;
  //   border-radius: 50px;
  justify-content: center;
  display: flex;
  margin: 0px;

  img {
    margin-top: 3px;
    cursor: pointer;
  }
`
